import { useNavigate } from '@tanstack/react-router';
import { FileArrowUpIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useFeatureFlag } from '@/integrations/feature-flags/feature-flags';
import paths from '@/paths';

export function ToolsMenu() {
  const navigate = useNavigate();
  const { enabled: fileExtractionEnabled } = useFeatureFlag(
    'tools-page-file-extraction-enabled',
    false,
  );

  if (!fileExtractionEnabled) {
    return null;
  }

  return (
    <DropdownMenu
      onOpenChange={(open) => {
        if (!open) {
          (document.activeElement as HTMLElement | null)?.blur();
        }
      }}
    >
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="focus-visible:ring-0 data-[state=open]:bg-transparent"
        >
          <T context="top navbar tools dropdown label">Tools</T>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() =>
            navigate({ to: paths.authenticated.tools.fileExtraction })
          }
        >
          <FileArrowUpIcon />
          <T context="tools menu item for file extraction page">
            File Extraction
          </T>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
